/* eslint-disable react-hooks/exhaustive-deps */
import { unwrapResult } from "@reduxjs/toolkit";
import { Button, Radio, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../app/store";
import { CirclePieCharts } from "../../components/CirclePieCharts";
import { SupervisorSelectModal } from "../../components/modal/SupervisorSelectModal";
import styles from "./HealthPrisonAnaylse.module.css";
import { getHealthPrisonAnaylseData } from "./HealthPrisonAnaylseSilce";
import { Skeleton } from "./Skeleton";

export const HealthProportionAnaylse = () => {
  const [time, setTime] = useState();

  const [medicalData, setMedicalData] = useState<any>([]);

  const [cautionData, setCautionData] = useState<any>([]);

  const [handleData, setHandleData] = useState<any>([]);

  const [selectData, setSelectData] = useState<any>([]);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (selectData.length) {
      dispatch(
        getHealthPrisonAnaylseData({
          scope: time,
          osIds:
            selectData
              .map((v: any) => {
                return v.osId;
              })
              .join(",") || "",
        })
      )
        .then(unwrapResult)
        .then((res) => {
          setMedicalData(
            res.map((v) => {
              return {
                name: v.name,
                value: v.medicalTotal,
              };
            })
          );
          setCautionData(
            res.map((v) => {
              return {
                name: v.name,
                value: v.cautionTotal,
              };
            })
          );
          setHandleData(
            res.map((v) => {
              return {
                name: v.name,
                value: v.handleTotal,
              };
            })
          );
        });
    }
  }, [time, selectData]);
  return (
    <div className={styles.proportion}>
      <div className={styles.dataSelect}>
        <Button
          type='primary'
          onClick={() => setIsModalVisible(true)}
          style={{ marginRight: '10px' }}
        >
          选择卫健委(局)
        </Button>
        {selectData?.map((v: any) => {
          return (
            <Tag
              key={v.osId}
              closable
              color='processing'
              onClose={() => {
                setSelectData(
                  selectData.filter((item: any) => item.osId !== v.osId)
                )
              }}
              style={{ margin: '10px' }}
            >
              {v.osName}
            </Tag>
          )
        })}

        <Radio.Group
          defaultValue={time}
          onChange={(e: any) => {
            setTime(e.target.value)
          }}
          optionType='button'
          buttonStyle='solid'
          style={{ float: 'right' }}
        >
          <Radio.Button value={0}>近七天</Radio.Button>
          <Radio.Button value={1}>近30天</Radio.Button>
          <Radio.Button value={2}>近一年</Radio.Button>
          <Radio.Button>全部</Radio.Button>
        </Radio.Group>
      </div>
      {selectData.length &&
      medicalData.length &&
      cautionData.length &&
      handleData.length ? (
        <div className={styles.piebox}>
          <div className={styles.anaylseCard}>
            <CirclePieCharts
              pieTitle='不同卫健委(局)诊疗数据展示'
              pieData={medicalData}
              style={{ height: '100%', padding: '10px' }}
            />
          </div>
          <div className={styles.anaylseCard}>
            <CirclePieCharts
              pieTitle='不同卫健委(局)预警数据展示'
              pieData={cautionData}
              style={{ height: '100%', padding: '10px' }}
            />
          </div>
          <div className={styles.anaylseCard}>
            <CirclePieCharts
              pieTitle='不同卫健委(局)处置数据展示'
              pieData={handleData}
              style={{ height: '100%', padding: '10px' }}
            />
          </div>
        </div>
      ) : (
        <Skeleton
          infoMsg={selectData.length ? '切换卫健委(局)' : '选择卫健委(局)'}
          isSelect={() => {
            setIsModalVisible(true)
          }}
        />
      )}
      <SupervisorSelectModal
        mode='checkbox'
        initialValue={selectData}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={() => setIsModalVisible(false)}
        onChange={(s) => setSelectData(s)}
      />
    </div>
  )
};
